/**************************************************
 * Nombre:       Seccion_Espacios
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Tabla_Filtro from "../../Modulo_Tabla_2025/Componentes/Tabla_Filtro";
import {
    CASILLA_ESTADO,
    CASILLA_FECHA_DATO,
    CASILLA_FECHA_DATOS, CASILLA_IMG,
    CASILLA_TEXTO
} from "../../Modulo_Tabla_2025/Componentes/SubComponentes/obtenerCasilla";
import {useObtenerColleccionTabla2025} from "../../Servicios/BD/useObtenerColleccionTabla2025";
import React from "react";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import {ManageSearch,Group,CircleNotifications,Book} from "@mui/icons-material";
import {ESTADOSPEDIDOS} from "../../Constantes";
import {useNavigate} from "react-router";
import Dialogo_Espacio from "../Dialogos/Espacios/Dialogo_Espacio";
import Dialogo_Espacio_Notificaciones from "../Dialogos/Espacios/Dialogo_Espacio_Notificaciones";
import Dialogo_Blog from "../Dialogos/Dialogo_Blog";
import Dialogo_Espacio_Blog from "../Dialogos/Espacios/Dialogo_Espacio_Blog";


const Seccion_Espacios = () => {
    const navigate = useNavigate();
    const {props, setData, setNumeroFilas, cargarNuevamente} = useObtenerColleccionTabla2025({coleccion: 'cursos'})
    const {Dialogo, abrir} = useDialogo({
        Componente: Dialogo_Espacio,
        titulo: 'Detalles la Espacio',
        realizado: cargarNuevamente
    })
    const {Dialogo:DialogoNotificaciones, abrir:abrirNotificacion} = useDialogo({
        Componente: Dialogo_Espacio_Notificaciones,
        titulo: 'Notificaciones del Espacio',
        realizado: cargarNuevamente
    })
    const {Dialogo:DialogoBlog, abrir:abrirBlog} = useDialogo({
        Componente: Dialogo_Espacio_Blog,
        titulo: 'Blog del Espacio',
        realizado: cargarNuevamente
    })

    const click = (id, data) => {
        switch (id) {
            case 'detalles':
                abrir(data)
                break;
            case 'notificaciones':
                abrirNotificacion(data)
                break;
            case 'blog':
                abrirBlog(data)
                break;
            case 'inscritos':
                navigate(`/Potenciales/${data.id}`)
                break;
            default :
                abrir(data)
        }
    }

    return (

        <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1200px'}}
                spacing={3}
            >

                <Dialogo/>

                <DialogoNotificaciones/>

                <DialogoBlog/>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Tabla_Filtro
                        nombre={'Lista de Oferta Academica'}
                        descripcion={`${props.numeroFilas} en base de datos`}
                        filtros={filtros}
                        datosCabecera={datosCabecera}
                        {...props}
                        clickAgregar={abrir}
                        botonesData={botonesData}
                        clickData={click}
                        // funcionBuscar={funcionBuscar}
                        //  botones={[]}
                        //ComponenteInferior={ExportadorDatos}

                    />
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Seccion_Espacios

const filtros = [
    {
        nombre: 'Nombre',
        direccion: 'asc',
        propiedad: 'nombre'
    },
    {
        nombre: 'Mas Reciente',
        direccion: 'desc',
        propiedad: 'fecha'
    },
]


const datosCabecera = [
    {
        nombre: 'Img',
        direccion: 'left',
        propiedad: 'img',
        size: 52,
        tipo: CASILLA_IMG
    },
    {
        nombre: 'Nombre',
        direccion: 'left',
        propiedades: ['nombreResaltado', 'nombre'],
        fecha: 'fecha',
        tipo: CASILLA_FECHA_DATOS
    },
    {
        nombre: 'Fecha Programada',
        direccion: 'left',
        propiedad: 'profesional',
        fecha: 'fechaEspacio',
        tipo: CASILLA_FECHA_DATO

    },
    {
        nombre: 'Esacio',
        direccion: 'left',
        propiedad: 'espacio',
        tipo: CASILLA_TEXTO

    },
    {
        nombre: 'Estado',
        direccion: 'right',
        propiedad: 'estado',
        tipo: CASILLA_ESTADO,
        estados: ESTADOSPEDIDOS
    },

]

const botonesData = [
    {
        nombre: 'Detalles',
        id: 'detalles',
        icono: ManageSearch
    },
    {
        nombre: 'Inscritos',
        id: 'inscritos',
        icono: Group
    },
    {
        nombre: 'Notificaciones',
        id: 'notificaciones',
        icono: CircleNotifications
    },
    {
        nombre: 'Blog',
        id: 'blog',
        icono: Book
    },
]

